import { Moment } from 'moment-timezone';
import { equals } from 'ramda';
import React, { useEffect, useMemo, useState } from 'react';
import { Features } from '../../../models/features';
import { LocaleSettings } from '../../../models/location';
import { GetShipmentsQuery } from '../../../ports/ShipmentsService';
import { FlexBox, FlexDirection, FlexGrow } from '../../../utils/css-classes';
import { Select } from '../../Select';
import DateFilter from '../../ShipmentsTable/filters/DateFilter';
import ReferencesFilter from '../../ShipmentsTable/filters/ReferencesFilter';
import { FeatureToggle } from '../../utils/FeatureToggle';

// tslint:disable-next-line:import-name
import style from './index.module.css';

// tslint:disable-next-line:function-name
export function ShipmentGroupExplorerFilters(
  {
    localeSettings,
    onFiltersChange,
  }: {
    localeSettings: LocaleSettings;
    onFiltersChange: (query: GetShipmentsQuery) => void;
  },
) {

  const [references, setReferences] = useState<string[]>([]);
  const [tagOptions, setTagOptionss] = useState<{ value: string; label: string; }[]>([]);
  const [createdBefore, setCreatedBefore] = useState<Moment>();
  const [createdAfter, setCreatedAfter] = useState<Moment>();
  const tags = useMemo(() => tagOptions.map(({ value }) => value), [tagOptions]);

  const [query, setQuery] = useState<GetShipmentsQuery>({});

  useEffect(
    () => {
      if (
        !equals(references, query.references) ||
        !equals(createdBefore?.utc().format(), query.createdBefore) ||
        !equals(createdAfter?.utc().format(), query.createdAfter) ||
        !equals(tags, query.tags)
      ) {
        const q: GetShipmentsQuery = {
          tags,
          references,
          createdBefore: createdBefore?.utc().format(),
          createdAfter: createdAfter?.utc().format(),
        };
        setQuery(q);
        onFiltersChange(q);
      }
    },
    [
      createdBefore,
      createdAfter,
      references,
      tags,
    ],
  );

  return <div className={`${FlexBox.FLEX} ${FlexDirection.ROW}`}>
    <ReferencesFilter
      onChange={setReferences}
      className={FlexGrow.GROW_1}
    />&nbsp;
    <FeatureToggle whenFlag={Features.VENLO_TAG_FILTER} isEnabled>
      <div className={style.VenloTags}>
        <h6>Tags</h6>
        <Select
          isClearable
          options={[
            { label: 'albumprinter', value: 'albumprinter' },
            { label: 'venlo', value: 'venlo' },
          ]}
          value={tagOptions}
          onChange={value => Array.isArray(value) ? setTagOptionss([...value]) : setTagOptionss(value ? [value] : [])}
        />
      </div>
    </FeatureToggle>
    <DateFilter
      title="Created after"
      localeSettings={localeSettings}
      onChange={setCreatedAfter}
      isValidDate={(current: Moment) => createdBefore ? current.isBefore(createdBefore) : true}
    />&nbsp;
    <DateFilter
      title="Created before"
      localeSettings={localeSettings}
      onChange={setCreatedBefore}
      isValidDate={(current: Moment) => createdAfter ? current.isAfter(createdAfter) : true}
    />
  </div>;
}
